import React from 'react';
import { SampleCardProps } from './Success';
import './SampleCard.scss';

const SampleCard: React.FC<SampleCardProps> = ({ title, subtitle, image, actionText, actionLink }) => {
  return (
    <div className="card">
      <div className="img-wrapper">
        <img src={image} alt="" />
      </div>
      <div className="card-content">
        <h2>{title}</h2>
        <p>{subtitle}</p>
        <a className="button" href={actionLink} target="_blank" rel="noopener noreferrer">
          {actionText}
        </a>
      </div>
    </div>
  );
};

export default SampleCard;
